import { defineMessages } from "react-intl";

export const scope = "components.DownloadInvoice";

export const messages = defineMessages({
  downloadButton: {
    id: `${scope}.downloadButton`,
    defaultMessage: "DESCARGAR COMPROBANTE FISCAL",
  },
  awaitningInvoice: {
    id: `${scope}.awaitningInvoice`,
    defaultMessage:
      "El comprobante fiscal puede demorar hasta 10 días hábiles. Una vez generado lo podrás descargar desde aquí.",
  },
});
